module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAABvSURBVHgB7djBCYAwEETRxQoswRIswU60c0tZ14MFCIGdIf9B7vNDTokAAGBmmbnW2cJVjd/r3O4RFxEKiFBBhAoiVBChgggVIyOW6JHhqm79tH1CjO/C+C6M78L4Lozv4j7+sB3/eT94AwAA/PcAniog/gJE9GYAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/right.png
// module id = SuS5
// module chunks = 0